'use client'

import { RefObject, useEffect, useLayoutEffect, useRef, useState } from "react";
import css from "./SlideText.module.scss"

import 'swiper/css';
import 'swiper/css/navigation';
import "swiper/css/autoplay";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import clsx from "clsx";

interface Props<T extends HTMLElement> {
    coverEl: HTMLElement | null
    text: string
    speed?: number
    betweenDivisor?: number
    fontSize?: number
    autoSlide?: boolean
}

function SlideText<T extends HTMLElement>({
    coverEl,
    text,
    speed = 5000,
    betweenDivisor = 2,
    fontSize = 16,
    autoSlide = false
}: Props<T>) {
    const textRef = useRef<HTMLDivElement>(null)

    const [animation, setAnimation] = useState<boolean>(false)
    const [between, setBetween] = useState<number>(0)
    const [slideWidth, setSlideWidth] = useState<number>(0)

    useLayoutEffect(() => {
        const cover = coverEl;
        const textEl = textRef.current;
        console.log("****************************************")
        console.log("cover", cover)
        console.log("textEl", textEl)

        if (!cover || !textEl) return;

        let frameId = 0;

        const measure = () => {
            const coverWidth = Math.ceil(
                cover.getBoundingClientRect().width
            );

            const textWidth = Math.ceil(
                textEl.getBoundingClientRect().width
            );

            if (!coverWidth || !textWidth) return;

            const isShort = textWidth < coverWidth * 0.6;

            const nextSlideWidth = isShort
                ? coverWidth * 0.6
                : textWidth;

            const nextBetween = Math.min(
                120,
                isShort
                    ? 1
                    : textWidth / Math.max(betweenDivisor, 1)
            );

            setSlideWidth(nextSlideWidth);
            setBetween(nextBetween);
            setAnimation(autoSlide || coverWidth < textWidth);

            // console.log(text)
            // console.log(nextSlideWidth)
            // console.log(nextBetween)
            // console.log(autoSlide)
            // console.log(coverWidth < textWidth)
        };

        const requestMeasure = () => {
            cancelAnimationFrame(frameId);
            frameId = requestAnimationFrame(measure);
        };

        measure();

        const resizeObserver = new ResizeObserver(requestMeasure);

        resizeObserver.observe(cover);
        resizeObserver.observe(textEl);

        document.fonts?.ready?.then(requestMeasure);

        return () => {
            cancelAnimationFrame(frameId);
            resizeObserver.disconnect();
        };
    }, [coverEl, text, fontSize, autoSlide, betweenDivisor]);

    return (
        <>
            <div className={clsx(css.hiddenLayout, "build-3")}>
                <div ref={textRef} className={clsx(css.hidden)} style={{ fontSize: `${fontSize}px` }} dangerouslySetInnerHTML={{ __html: text }}></div>
            </div>
            
            {
                animation && slideWidth
                    ? <>
                        <Swiper
                            modules={[Autoplay]}
                            loop={true}
                            spaceBetween={between || 40}
                            slidesPerView="auto"
                            speed={speed}
                            autoplay={{
                                delay: 0,                    // 자동 전환
                                disableOnInteraction: false,
                            }}
                        >
                            {
                                [...Array(3)].map((_, idx) => (
                                    <SwiperSlide key={idx} style={{ width: "max-content", fontSize: `${fontSize}px` }}>
                                        <Text className="loop" text={text} fontSize={fontSize} />
                                    </SwiperSlide>
                                ))
                            }
                        </Swiper>
                    </>
                    : <Text className="normal" text={text} fontSize={fontSize} />
            }
        </>
    )
}

export default SlideText;

interface TextProps {
    className: string
    text: string
    fontSize: number
}
function Text({ className, text, fontSize = 14 }: TextProps) {
    return (
        <div className={css[className]}
            style={{ fontSize: `${fontSize}px` }}
            dangerouslySetInnerHTML={{ __html: `${text}` }} />
    )
}